import { ifSelectorExist, getElements } from '../utils'
import Glide from "@glidejs/glide";

export const vacationSliders = () => {

  const availableDaysSlider = ".available-days--slider";
  if (ifSelectorExist(availableDaysSlider)) {
    Array.from(getElements(availableDaysSlider)).forEach((item) => {
      new Glide(item, {
        perView: 4.3,
        type: "slider",
        animationDuration: 300,
        autoplay: 0,
        breakpoints: {
          1150: {
            perView: 3.3,
          },
          600: {
            perView: 1.6,
          }
        }
      }).mount();
    });
  }
}
